import component from './overview/SimulationTemplateOverview';

export const page = {
    title: 'simulationTemplates.title',
    path: '/simulationTemplates',
    icon: 'copy',
    component
}
